import React from 'react';
import { Grid, Image, Header, Button, Icon } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';

const AppInfoAccount = () => {
  const navigate = useNavigate();

  return (
    <Grid>
      {/* 상단: 서비스 식별 */}
      <Grid.Row columns={16} textAlign="left" style={{ paddingBottom: 0 }}>
        <Grid.Column width={16}>
          <Header as="h2" textAlign="left">
            파이보(pibo) 계정 해지 및 데이터 삭제 안내
          </Header>
          <Header as="h3" textAlign="left" style={{ margin: '0.25em 0' }}>
            파이보(pibo) 서비스 이용을 중단하시나요?
          </Header>
          <ul
            style={{
              fontSize: '1rem',
              color: '#666',
              textAlign: 'left',
              paddingInlineStart: '1rem',
              marginBottom: 0,
            }}
          >
            <li>
              파이보(pibo) 계정을 해지하고 데이터를 영구적으로 삭제하려면 다음
              버튼을 선택하세요.
            </li>
            <li>
              <strong>메뉴</strong> - <strong>계정 설정</strong> -{' '}
              <strong>탈퇴</strong> 메뉴에서 탈퇴를 진행해주세요.
            </li>
          </ul>

          <Button
            primary
            style={{ margin: '1em 0' }}
            onClick={() => navigate('/login')}
          >
            로그인 후 탈퇴하기
            <Icon name="chevron right" />
          </Button>
          <p style={{ fontSize: '1rem', color: '#666', textAlign: 'left' }}>
            <strong>참고:</strong> 사용했던 아이디는 탈퇴할 경우 재사용 및
            복구가 불가능합니다. 탈퇴 후 회원정보 및 봇스토어 리뷰를 제외한
            파이보 모바일 서비스 이용기록은 모두 삭제되며, 삭제된 데이터는
            복구되지 않습니다.
          </p>
        </Grid.Column>
      </Grid.Row>
      {/* 중앙: 두 가지 탈퇴 경로 */}
      {/* <Grid.Row columns={16}>
          <Grid.Column width={16}>
            <Segment placeholder style={{ border: 'none', boxShadow: 'none' }}>
              <Grid columns={1} stackable textAlign="center">
                <Grid.Row verticalAlign="middle">
                  <Grid.Column>
                    <Header icon>
                      <Icon name="mail" />
                      이메일 요청 (로그인 불가 시)
                    </Header>
                    <p>
                      비밀번호를 분실했거나 로그인이 어려운 경우,
                      <br />
                      아래 메일로 신청해 주세요.
                    </p>
                    <p
                      style={{
                        marginTop: '0.5rem',
                        fontSize: '0.9em',
                        color: '#888',
                      }}
                    >
                      다음과 같은 양식으로 이메일을 보내주시면 7~10일 이내에
                      탈퇴 처리를 도와드립니다. [파이보모바일-탈퇴요청] 제목로
                      이메일을 보내주시고, 본문에는 다음 정보를 포함해 주세요: -
                      가입 이메일 또는 휴대폰 번호 - 사용 닉네임 - 탈퇴 사유
                      (선택 사항)
                    </p>
                    <Button as="a" href="mailto:support@circul.us">
                      메일 보내기
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid.Row> */}
      <Grid.Row columns={16} textAlign="left" style={{ margin: '2rem 0' }}>
        <Grid.Column
          width={16}
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Image
            src="/image/logo_circulus.png"
            alt="Circulus Logo"
            style={{ height: '30px' }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default AppInfoAccount;
